import { Navigate } from "@tanstack/react-router";

/**
 * Посадка ссылок СТАРОГО SSO.
 *
 * На Э5 `sso.iec.exchange` начнёт обслуживаться нами, и вместе с живыми
 * запросами туда приедут ссылки из УЖЕ отправленных писем: подтверждение почты
 * (`/callback?token=`, живёт 7 суток), сброс пароля (`/reset-password`,
 * 60 минут), закладки на `/login`. Ни одного из этих экранов у нас нет —
 * человек упёрся бы в «Not Found» роутера ровно в тот момент, когда его
 * попросили что-то сделать.
 *
 * Редирект компонентом, а не `beforeLoad`: во всех трёх приложениях нет ни
 * одного `loader`/`beforeLoad` (`rules/frontend-state.md` §3), и заводить
 * первый ради увода со страницы незачем.
 *
 * `token` и `email` из адресной строки с собой НЕ уносятся: на `/error` схема
 * search — белый список, а сам токен бесполезен (пароля у нас нет, почту мы
 * подтверждаем кодом) и является чужим секретом.
 */
export function LegacyLinkRedirect() {
	return <Navigate to="/error" search={{ error: "legacy_link" }} replace />;
}
